import { ChangeEvent, FC, useState } from "react";
import { Spinner } from "reactstrap";

interface SearchTableProps {
    onSearch: (value: string) => void;
    loading?: boolean;
    className?: string;
    placeholder?: string;
}

export const SearchTable: FC<SearchTableProps> = ({ onSearch, loading=false, className, placeholder }) => {

    let timeOut: any = null;

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        clearTimeout(timeOut);
        timeOut = setTimeout(async () => {
            const value = e.target.value.trim();
            onSearch(value);
        }, 600);

    };

  return (
    <div className={" " + className}>
        <div className="d-flex" >
            <input
                type="text"
                className="form-control "
                placeholder={placeholder ? placeholder : "Search..." }
                onChange={handleSearch}
                style={{ border: '2px solid #D8C8B8', borderTopRightRadius: '0', borderBottomRightRadius: '0', minWidth: '250px' }}
            />
            <button 
                className="btn btn-primary" 
                type="button"
                style={{ borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}
            >
                {
                    loading ? (
                        <Spinner size="sm" color="light" />
                    ) : <i className="bx bx-search-alt align-middle"></i>
                }
                
            </button>
        </div>
    </div>
  )
}
